<template>
  <KiaHeader />
</template>

<script setup lang="ts">
// No explicit import needed, Nuxt will auto-import KiaHeader
</script> 